import FormattedMessage from 'I18n/components/FormattedMessage';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { PROPERTY_MATCHING_DATA_SOURCES } from 'automation-ui-formula-editor/constants/Gates';
import { SelectRecordBy } from 'automation-ui-formula-editor/fetch-object-panel/containers/fields/utils/selectRecordBy';
import { selectTargetObjectChangeAction, selectFilterRecordsByAction, selectAssociationIdAction, selectSortByAction, selectSortByAssociationTimestampAction, selectMatchingDataSourcePropertyAction, selectMatchingEnrolledPropertyAction, selectMatchingPropertyValueAction, renameDataSourceAction } from 'automation-ui-formula-editor/fetch-object-panel/actions/addDataSourceActions';
import AddDataSourceSelectTargetObject from 'automation-ui-formula-editor/fetch-object-panel/containers/AddDataSourceSelectTargetObject';
import AddDataSourceFilterRecordsBy from 'automation-ui-formula-editor/fetch-object-panel/containers/AddDataSourceFilterRecordsBy';
import AddDataSourcePropertyMatch from 'automation-ui-formula-editor/fetch-object-panel/containers/AddDataSourcePropertyMatch';
import AddDataSourceSelectAssociation from 'automation-ui-formula-editor/fetch-object-panel/containers/AddDataSourceSelectAssociation';
import AddDataSourceBasicSortBy from 'automation-ui-formula-editor/fetch-object-panel/containers/AddDataSourceBasicSortBy';
import AddDataSourceFilterRecordsByTypes from 'automation-ui-formula-editor/fetch-object-panel/constants/AddDataSourceFilterRecordsByTypes';
import { RecordFilterTypes } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { getFilterRecordsByType } from 'automation-ui-formula-editor/fetch-object-panel/utils/getFilterRecordsByType';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DataSourceForm({
  componentState,
  dispatch,
  flowObjectTypeId,
  objectTypeFilter,
  setAssociationSelectedName,
  readOnly = false,
  isNewDataSource
}) {
  var _ref, _componentState$recor;
  const isUngatedToPropertyMatching = useIsUngated(PROPERTY_MATCHING_DATA_SOURCES);
  const filterRecordsByType = getFilterRecordsByType(componentState);
  const selectRecordByValue = (_ref = componentState.recordFilterDefinition.associationTimestampOrder) !== null && _ref !== void 0 ? _ref : componentState.recordFilterDefinition.selectRecordBy;
  const handleChangeAssociation = (associationId, associationName) => {
    setAssociationSelectedName === null || setAssociationSelectedName === void 0 || setAssociationSelectedName(associationName);
    dispatch(selectAssociationIdAction({
      associationId
    }));
  };
  const handleTargetObjectChange = objectTypeId => {
    dispatch(selectTargetObjectChangeAction({
      objectTypeId
    }));
    if (!isUngatedToPropertyMatching) {
      dispatch(selectFilterRecordsByAction({
        recordFilterType: AddDataSourceFilterRecordsByTypes.ASSOCIATION_LABEL
      }));
      handleChangeAssociation('', '');
    }
  };
  const handleFilterObjectByChange = event => {
    const recordFilterType = event.target.value;
    if (recordFilterType === AddDataSourceFilterRecordsByTypes.PROPERTY_VALUE) {
      dispatch(selectFilterRecordsByAction({
        recordFilterType: RecordFilterTypes.MATCHING_PROPERTY
      }));
      dispatch(selectMatchingPropertyValueAction({
        value: ''
      }));
    } else {
      dispatch(selectFilterRecordsByAction({
        recordFilterType
      }));
    }
  };
  const handleDataSourcePropertyChange = propertyName => {
    dispatch(selectMatchingDataSourcePropertyAction({
      propertyName
    }));
    if (filterRecordsByType === AddDataSourceFilterRecordsByTypes.PROPERTY_VALUE) {
      dispatch(selectMatchingPropertyValueAction({
        value: ''
      }));
    }
  };
  const handleEnrolledPropertyChange = propertyName => {
    dispatch(selectMatchingEnrolledPropertyAction({
      propertyName
    }));
  };
  const handleMatchingPropertyValueChange = value => {
    dispatch(selectMatchingPropertyValueAction({
      value
    }));
  };
  const handleSortByChange = event => {
    const selectRecordBy = event.target.value;
    if ([SelectRecordBy.MOST_RECENTLY_ASSOCIATED, SelectRecordBy.FIRST_ASSOCIATED].includes(selectRecordBy)) {
      dispatch(selectSortByAssociationTimestampAction({
        associationTimestampOrder: selectRecordBy
      }));
    } else {
      if (componentState.recordFilterDefinition.recordFilterType === RecordFilterTypes.ASSOCIATION_TIMESTAMP) {
        dispatch(selectFilterRecordsByAction({
          recordFilterType: RecordFilterTypes.ASSOCIATION_LABEL
        }));
      }
      dispatch(selectSortByAction({
        selectRecordBy
      }));
    }
  };
  const handleRenameDataSource = event => {
    dispatch(renameDataSourceAction({
      label: event.target.value
    }));
  };
  return /*#__PURE__*/_jsxs(UIForm, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.label"
      }),
      children: /*#__PURE__*/_jsx(UITextInput, {
        value: componentState.label,
        onChange: handleRenameDataSource,
        readOnly: readOnly
      })
    }), /*#__PURE__*/_jsx(AddDataSourceSelectTargetObject, {
      flowObjectTypeId: flowObjectTypeId,
      onChange: handleTargetObjectChange,
      objectTypeId: componentState.objectTypeId,
      objectTypeFilter: objectTypeFilter,
      readOnly: readOnly || !isNewDataSource
    }), isUngatedToPropertyMatching && componentState.objectTypeId && /*#__PURE__*/_jsx(AddDataSourceFilterRecordsBy, {
      flowObjectTypeId: flowObjectTypeId,
      objectTypeId: componentState.objectTypeId,
      value: filterRecordsByType,
      onChange: handleFilterObjectByChange,
      filterTargetType: componentState.recordFilterDefinition.filterTargetType,
      isNewDataSource: isNewDataSource,
      readOnly: readOnly
    }), componentState.objectTypeId && AddDataSourceFilterRecordsByTypes.ASSOCIATION_LABEL === filterRecordsByType && /*#__PURE__*/_jsx(AddDataSourceSelectAssociation, {
      flowObjectTypeId: flowObjectTypeId,
      toObjectTypeId: componentState.objectTypeId,
      onChange: handleChangeAssociation,
      value: (_componentState$recor = componentState.recordFilterDefinition.associationId) !== null && _componentState$recor !== void 0 ? _componentState$recor : '',
      onSortByChange: handleSortByChange,
      selectRecordByValue: selectRecordByValue,
      filterTargetType: componentState.recordFilterDefinition.filterTargetType,
      isNewDataSource: isNewDataSource,
      readOnly: readOnly
    }), componentState.objectTypeId && (AddDataSourceFilterRecordsByTypes.MATCHING_PROPERTY === filterRecordsByType || AddDataSourceFilterRecordsByTypes.PROPERTY_VALUE === filterRecordsByType) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AddDataSourcePropertyMatch, {
        flowObjectTypeId: flowObjectTypeId,
        toObjectTypeId: componentState.objectTypeId,
        dataSourcePropertyName: componentState.recordFilterDefinition.propertyName,
        matchingValue: componentState.recordFilterDefinition.matchingValue,
        onDataSourcePropertyChange: handleDataSourcePropertyChange,
        onEnrolledPropertyChange: handleEnrolledPropertyChange,
        onMatchingPropertyValueChange: handleMatchingPropertyValueChange,
        readOnly: readOnly
      }), /*#__PURE__*/_jsx(AddDataSourceBasicSortBy, {
        onSortByChange: handleSortByChange,
        flowObjectTypeId: flowObjectTypeId,
        toObjectTypeId: componentState.objectTypeId,
        selectRecordByValue: selectRecordByValue,
        recordFilterType: filterRecordsByType,
        filterTargetType: componentState.recordFilterDefinition.filterTargetType,
        isNewDataSource: isNewDataSource,
        readOnly: readOnly
      })]
    })]
  });
}